import React from 'react'
import OrderSuccessBlock from '../components/OrderSuccessBlock'

const OrederSuccess = () => {
  return (<OrderSuccessBlock />)
}

export default OrederSuccess
